export class CampaignEntity {
    id;
    name;
    type;
    createdDate;
    createdBy;
    subject;
    body;
    link;
    attachment;
    attachmentName;
    siteId;
    deleted;

    constructor(id, name, type, createdDate, createdBy, subject, body, link, attachment, attachmentName, siteId, deleted) {
        this.id = id;
        this.name = name;
        this.type = type;
        this.createdDate = createdDate;
        this.createdBy = createdBy;
        this.subject = subject;
        this.body = body;
        this.link = link;
        this.attachment = attachment;
        this.attachmentName = attachmentName;
        this.siteId = siteId;
        this.deleted = deleted;
    }
}